import React, { useContext } from 'react';
import classNames from 'classnames';
import { extend, QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { CollectionRedirector } from '@thd-nucleus/app-render';
import { node } from 'prop-types';
import { CollectionDesktop } from '@thd-olt-component-react/collection';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { EmtLinks } from '@thd-olt-component-react/emt-links';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { CollectionMetadata, Metadata } from '@thd-olt-component-react/metadata';
import { RecentlyViewedWrapper } from '@thd-olt-component-react/thd-recs-containers';
import { useLocation, useParams } from '@thd-olt-component-react/router';
import { SearchFeedback } from '@thd-olt-component-react/search-feedback';
import '../../styles/collections.scss';
import { useThdCustomer } from '@thd-olt-functional/customer-information';

const ZoneCard = ({ children }) => {
  return <div className="zone-card">{children}</div>;
};

ZoneCard.propTypes = {
  children: node.isRequired
};

export const Collections = (props) => {
  declareContexts([QueryContext, ExperienceContext]);
  const { isCustomerIdentified = false } = useThdCustomer();
  const { collectionId } = useParams();
  const { search: queryString, pathname } = useLocation();
  const { storeId, isLocalized } = useStore();
  const collectionItems = ''; // TODO
  const { hosts } = useContext(ExperienceContext);

  const query = ((queryString || '').match(/(\w+)=([^&]+)/g) || [])
    .map((val) => {
      const param = val.split('=');
      return {
        [param[0]]: param[1]
      };
    })
    .reduce((acc, next) => {
      const key = Object.keys(next)[0];
      return {
        ...acc,
        [key]: next[key]
      };
    }, {});
  const preview = (query?.preview === 'true');
  const isSpaceCollection = collectionId.includes('id');

  const greyBg = classNames({
    'grey-bg': isSpaceCollection
  });

  const defaultVariables = {
    storeId,
    skipImageBoundBox: true,
    skipKPF: true
  };
  if (isSpaceCollection) {
    defaultVariables.preview = preview;
    defaultVariables.skipImageBoundBox = false;
  }

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="collections-desktop">
      <CollectionRedirector
        collectionId={collectionId}
        storeId={storeId}
      />
      <Metadata>
        <CollectionMetadata collectionId={collectionId} />
      </Metadata>
      <Row className="isBound collections">
        <ErrorBoundary name="collection">
          <CollectionDesktop
            collectionId={collectionId}
            preview={preview}
          />
        </ErrorBoundary>
        <Col className={greyBg}>
          <ErrorBoundary name="search-feedback">
            <SearchFeedback type="collection" />
          </ErrorBoundary>
        </Col>
        <QueryProvider
          cacheKey="rv-collection-recs"
          persist
          defaultVariables={{ isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false }}
        >
          <RecentlyViewedWrapper
            schemaName="rv_gm_pip_rr"
            errorBoundary
            hydrator={{
              className: 'grid',
              tag: ZoneCard,
              id: 'rv_gm_pip_rr',
              scrollBuffer: 1200,
              delay: 2000
            }}
          />
        </QueryProvider>
        <EmtLinks
          path={pathname}
          layoutGroup={{
            tag: Row
          }}
          dynamic={{
            pageType: 'collection',
          }}
          hydrator={{
            className: 'grid'
          }}
        />
      </Row>
    </QueryProvider>
  );
};

Collections.dataModel = extend(
  CollectionDesktop,
  CollectionMetadata,
  CollectionRedirector,
  EmtLinks,
  RecentlyViewedWrapper
);
